/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-console */
/* eslint-disable react/no-danger */
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import fetch from "isomorphic-unfetch";
import Head from "next/head";
import LayoutV2 from "components/Layout/Layoutv2";
import { createBranchDeepLink } from "libs/BranchIO";
import { useRouter } from "next/router";
import { USER_PLATFORM } from "constants/tracking";
import config from "config";
import urls from "config/urls";
import {
	capitalizeFirstLetter,
	externalJobApplyCTA,
	getFAQSchema,
	getJobSchema,
	getUrlPath,
} from "utils/helpers";
import categoryData from "cms/category-data";
import {
	BRANCH_APP_DOWNLOAD_CAMPAIGNS,
	JOB_STATUS,
	PAGE_TYPES,
	IS_APPLY_BUTTON_CLICKED_EXTERNAL_JOB,
	LOCAL_STORAGE_KEYS,
	SESSION_STORAGE_KEYS,
} from "utils/constants";
import TagManagerUtils from "utils/TagManager";
import createJdFromJobDetails from "utils/jobDescriptionUtils";
import useBranchIoLinkGeneration from "utils/BranchIO";
import TopCompanies from "components/JobDetailsComponent/TopCompanies";
import { JobDetailJob, JobListJob } from "types/job";
import { JobApplicationType, TopCompaniesType } from "types/job/UseGetJobs";
import useTrackWebSession from "hooks/useTrackWebSession";
import useWebToAppBanner from "hooks/useWebToAppBanner";
import jobDetailfooterlinks from "data/jobdetails-footer.json";
import useIsDesktop from "hooks/useIsDesktop";
import { useCandidateProfile } from "modules/candidate/profile/hooks/useCandidateProfile";
import {
	applyJob,
	getECCSuccessScreen,
	getPrivateJobDetailsV7,
	registerJobApplicationOnWeb,
} from "utils/apiClientPrivate";
import { useCandidateProgress } from "modules/candidate/profile/hooks/useCandidateProgress";
import { isHostLaunchedMicrosite, isUserLoggedIn, isRHRUser, getUserId } from "utils";
import { useCandidateWebApplications } from "modules/candidate/profile/hooks/useCandidateWebApplications";
import NewThemedLayout from "components/ThemedComponent/Common/NewThemedLayout";

import { CircularProgress } from "@material-ui/core";
import InEligibleJobNudge from "components/Job/InEligibleJobNudge";
import { useIsJobAppliedAndEligibilityDetails } from "components/JobDetailsComponent/JobDetailsHeader/hooks/useIsJobAppliedAndEligibilityDetails";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import {
	APPLICATION_SENT_SUCCESSFUL_SCREEN_CTA_CLICKED,
	WEB_JOB_APPLICATION_INELIGIBLE_SCREEN_CTA_CLICKED,
} from "modules/jobDetails/constants/mixpanelConstants";
import ExternalJobAppliedFeedbackModal from "components/JobDetailsComponent/ExternalJobAppliedFeedbackModal";
import JobDetailsCard from "components/RevampFeedDetails/JobDetailsPage/components/JobDetailsCard";
import JobDetailsSection from "components/RevampFeedDetails/JobDetailsPage/components/JobDetailsSection";
import Image from "next/image";
import ShareIcon from "components/RevampFeedDetails/assets/ShareIcon";
import clsx from "clsx";
import { useWindowResize } from "utils/hooks";
import CompanyAddressIcon from "components/RevampFeedDetails/assets/CompanyAddressIcon";
import InfoIconOutline from "components/RevampFeedDetails/assets/InfoIconOutline";
import InfoIcon from "components/RevampFeedDetails/assets/InfoIcon";
import ClockIcon from "components/RevampFeedDetails/assets/ClockIcon";
import { mxpTrackSection } from "components/ThemedComponent/mixPannelEvents";
import ApplicationStatusScreen from "components/RevampFeedDetails/JobDetailsPage/components/ApplicationStatusScreen";
import RedirectToOnboarding from "components/RevampFeedDetails/JobDetailsPage/components/RedirectToOnboarding";
import SimilarJobsSection from "components/RevampFeedDetails/JobDetailsPage/components/SimilarJobsSection";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import { useCandidateConfiguration } from "modules/candidate/profile/hooks/useCandidateConfiguration";
import { GTAG_EVENTS, GTag } from "utils/Gtag";
import WalkInNudgeModal from "components/RevampFeedDetails/JobDetailsPage/components/WalkInNudgeModal";
import DownloadAppNudgeModal from "components/RevampFeedDetails/JobDetailsPage/components/DownloadAppNudge";
import FAQs from "components/RevampFeedDetails/JobDetailsPage/components/FAQs";
import DownArrow from "assets/svgs/DownArrow";
import JobExpiredModal from "components/RevampFeedDetails/JobDetailsPage/components/JobExpiredModal";
import { getJobsQNA, setJobAsAppliedInLS } from "utils/commonUtils";
import { useCandidateDetails } from "modules/candidate/profile/hooks/useCandidateDetails";
import { formatDate } from "utils/dateUtils";
import moment from "moment";
import { useJobDetails } from "modules/candidate/profile/hooks/useJobDetails";
import { SECTION_MAP } from "modules/candidate/profile/constants/sectionConstants";
import { LoginRefactoredContext } from "../../components/LoginRefactored/LoginContext";
import { AUTH_SOURCE } from "../../components/LoginRefactored/constants";

// const WebToAppBanner = dynamic(() => import("components/CTA/WebToAppBanner"));

// const Modal = dynamic(() => import("components/Modal/Modal"));

// const JobApplyContent = dynamic(
// 	() => import("components/ThemedComponent/Job/JobApplyContent")
// );

export type JobsProps = {
	job: JobDetailJob;
	jobSchema: string;
	faqSchema: string;
	slug: string;
	jobDescription: string;
	shortJobDescription: string;
	topCompanies: TopCompaniesType[];
	availableVendor?: string;
	jobOGUrl?: string;
	jobOGImageUrl?: string;
	jobOGError?: any;
	jobDescriptionTemplate?: string;
};

const Jobs: React.FC<JobsProps> = ({
	job,
	jobSchema,
	faqSchema,
	slug,
	jobDescription,
	shortJobDescription,
	jobDescriptionTemplate,
	// topCompanies,
	availableVendor,
	jobOGUrl,
	jobOGImageUrl,
}) => {
	// const isInternationalJob = job?.international_job_info?.is_international || false;
	const pageName = "Jobs Page";
	const jobCity = job?.address_v2?.city?.name || "";
	const jobArea = job?.address_v2?.area || "";
	const jobCompany = job?.organization?.name || "";
	const sharetext = `Hey! I found a ${job?.title} job on apna. check it out here 👇`;
	// const jobType = job?.type;
	const isBulkJob = job?.job_format === "bulk";
	const isWalkInJob = job?.is_walk_in;
	const router = useRouter();
	const expiryDate = job?.expiry ? new Date(job?.expiry) : false;
	const hasJobExpired = expiryDate
		? (expiryDate as Date).getTime() < Date.now()
		: false;
	useTrackWebSession(pageName);
	const date = moment();
	const today = date.format("MMM DD, YYYY");

	const [isMobileView] = useWindowResize();
	// const [isCtaOpen, setCtaOpen] = useState(false);
	const [showApplicationStatusScreen, setShowApplicationStatusScreen] = useState(false);
	const [showIneligibleModal, setShowIneligibleModal] = useState(false);
	const [isLoadingJobApply, setIsLoadingJobApply] = useState(false);
	const [showStickyJobDetailsBar, setShowStickyJobDetailsBar] = useState(false);
	const [pageVisibilityCount, setPageVisibilityCount] = useState(0);
	const [showExternalJobAppliedFeedbackModal, setShowExternalJobAppliedFeedbackModal] =
		useState(false);
	const [showRedirectingElement, setShowRedirectingElement] = useState(false);
	const [showWalkInEligibleBs, setShowWalkInEligibleBs] = useState(false);
	const [showDowloadAppModal, setShowDowloadAppModal] = useState(false);
	const category = (categoryData as any)?.find((c) => c.slug === job.category_slug);
	const vendor = availableVendor || isHostLaunchedMicrosite();
	const [isJobApplicationSuccess, setIsJobApplicationSuccess] =
		useState<boolean>(false);
	const isExternalJob = job?.is_external_job;

	const [isExternalJobApplied, setIsExternalJobApplied] = useState(false);
	const [similarJobs, setSimilarJobs] = useState([]);
	const [similarJobsJoading, setSimilarJobsLoading] = useState(false);
	const [loggedInApplyLink, setLoggedInApplyLink] = useState<string>("");
	const [postApplicationJobDetails, setPostApplicationJobDetails] = useState({});
	const [postApplicationEccScreenData, setPostApplicationEccScreenData] = useState({});
	const [showQNASection, setShowQNASection] = useState(false);
	const [isExpiredJobModalOpen, setIsExpiredJobModalOpen] = useState<boolean>(false);
	const [jobExpiredResponseData, setJobExpiredResponseData] = useState();
	const [moduleTrackData, setModuleTrackData] = useState({});
	const {
		data: appliedJobDetails,
		isLoading: isAppliedJobDetailsLoading,
		isError: appliedJobError,
	} = useIsJobAppliedAndEligibilityDetails(job?.id?.toString());
	const {
		data: candidateProfileData,
		isLoading: candidateProfileLoading,
		isLoadingError: isCandidateDetailsLoadingError,
	} = useCandidateProfile();
	const { data: candidateDetails } = useCandidateDetails(
		candidateProfileData?.phoneNumber
	);
	const { data: candidateOnboardingDetails, isLoading: isCandidateOnboardingLoading } =
		useCandidateProgress();
	const {
		data: candidateJobApplicationDetails,
		isLoading: isCandidateJobApplicationDetailsLoading,
	} = useCandidateWebApplications();
	// const { handleOpenToast } = useContext(ToastContext);
	const startAuth = useContext(LoginRefactoredContext);
	const { refetch: fetchCandidateConfig } = useCandidateConfiguration();

	const isCandidateEligible = useMemo(
		() =>
			isAppliedJobDetailsLoading
				? false
				: (appliedJobDetails as any)?.isCandidateEligible,
		[appliedJobDetails, isAppliedJobDetailsLoading]
	);
	const candidateJobApplicationCount = useMemo(
		() =>
			isCandidateJobApplicationDetailsLoading
				? 0
				: (candidateJobApplicationDetails as any)?.jobApplicationCount,
		[candidateJobApplicationDetails, isCandidateJobApplicationDetailsLoading]
	);

	const commonTrackEventsJobProperties = useMemo(() => {
		const obj = {
			"Job ID": job?.id,
			"Job city": job?.city_slug,
			"Job area": job?.area_slug,
			"Job Title": job?.title,
		};
		return obj;
	}, [job]);
	const jobRequirementsMPData = useMemo(() => {
		const { data = null } = appliedJobDetails?.job_requirement_mismatch || {};
		let JobReq;
		if (data?.requirements) {
			JobReq = data?.requirements.map((jobObj) => jobObj?.title);
		} else {
			JobReq = null;
		}
		return JobReq;
	}, [appliedJobDetails?.job_requirement_mismatch]);

	const deal_breaker_score = useMemo(
		() => (appliedJobDetails as any)?.candidateScore,
		[(appliedJobDetails as any)?.candidateScore]
	);

	const windowVisibilityCheck = () => {
		setPageVisibilityCount((prev) => prev + 1);
	};
	const jobDetailsCardRef = useRef(null);
	useEffect(() => {
		document.addEventListener("visibilitychange", windowVisibilityCheck);

		// Create an intersection observer instance
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						setShowStickyJobDetailsBar(true);
					} else {
						setShowStickyJobDetailsBar(false);
					}
				});
			},
			{ threshold: 0 }
		);

		// Start observing the target element
		if (jobDetailsCardRef.current) {
			observer.observe(jobDetailsCardRef.current);
		}
		if (!isUserLoggedIn()) {
			trackOnMixpanel("Login card shown", {
				Screen: "Job Detail Page Web",
			});
		}
		if (isUserLoggedIn()) {
			if (hasAppliedJobOnWeb) {
				trackOnMixpanel("Track your applications shown", {
					Screen: "Job Detail Page Web",
				});
			} else {
				trackOnMixpanel("Download app card shown", {
					Screen: "Job Details Page Web",
				});
			}
		}
		return () => {
			document.removeEventListener("visibilitychange", windowVisibilityCheck);
			observer.disconnect();
		};
	}, []);
	useEffect(() => {
		if (
			pageVisibilityCount % 2 !== 0 &&
			isExternalJob &&
			getIsApplyButtonClicked() === job?.id?.toString()
		) {
			setShowExternalJobAppliedFeedbackModal(true);
		}
	}, [pageVisibilityCount]);

	useEffect(() => {
		if (job?.data && job?.data?.status !== JOB_STATUS.ACTIVE) {
			setJobExpiredResponseData(job?.data);
			setIsExpiredJobModalOpen(true);
		}
		setModuleTrackData(
			JSON.parse(
				sessionStorage.getItem(SESSION_STORAGE_KEYS.MODULE_TRACKING_DATA) || "{}"
			)
		);
	}, [job]);

	useEffect(() => {
		const fetchSimilarJobs = async () => {
			if (!isUserLoggedIn()) {
				setSimilarJobsLoading(true);
				const response = await fetch(
					`${config.baseUrl + urls.PUBLIC_URL_JOB + job?.id}/suggested-jobs/`,
					{
						method: "GET",
					}
				)
					.then((r) => r.json())
					.catch((e) => {
						setSimilarJobsLoading(false);
						console.log(e);
					});

				setSimilarJobsLoading(false);
				setSimilarJobs(response);
			} else if (appliedJobDetails?.department_id) {
				setSimilarJobsLoading(true);
				const queryParams = {
					pagination: {
						page: 1,
						size: 10,
					},
				};

				const queryString = encodeURIComponent(JSON.stringify(queryParams));
				const response = await fetch(
					`${`${
						config.baseUrl
					}/jobfeed/job-feed/api/v3/user/${getUserId()}/element/|similar_jobs||${
						job?.id
					}||job_collection|department_${
						appliedJobDetails?.department_id
					}_jobs|?children=${queryString}`}`,
					{
						method: "GET",
						headers: {
							Accept: "application/json",
							Authorization: `Token ${isUserLoggedIn()}`,
						},
					}
				)
					.then((r) => r.json())
					.catch((e) => {
						setSimilarJobsLoading(false);
						console.log(e);
					});

				const simJobsFinal =
					response?.element?.data?.job_collection?.children?.elements?.reduce(
						(acc, e) => {
							const innerJob = e?.data?.job_card_square?.job;

							acc = innerJob ? [...acc, innerJob] : [...acc];
							return acc;
						},
						[]
					);

				setSimilarJobsLoading(false);
				setSimilarJobs(simJobsFinal);
			}
		};

		fetchSimilarJobs();
	}, [job, appliedJobDetails?.department_id]);
	const candidateDetailsRef = useRef(candidateDetails);
	useEffect(() => {
		candidateDetailsRef.current = candidateDetails;
	}, [candidateDetails]);
	const handleApplyJob = useCallback(async () => {
		if (isExternalJob) {
			setIsApplyButtonClicked("true", job?.id);
			if (isUserLoggedIn()) {
				const currentCandidateDetails = candidateDetailsRef.current;
				window.open(
					/**
					 * This is a hack for a intermittent inconsistent issue faced
					 * for the email application for jobTrek experiment.
					 */
					job?.external_job_url.includes("user=None")
						? job?.external_job_url.replace(
								"user=None",
								`user=${candidateProfileData?.userId}${
									currentCandidateDetails?.[SECTION_MAP.OVERALL]
										?.resumeDetails?.resumeLink
										? `&resume=${
												currentCandidateDetails?.[
													SECTION_MAP.OVERALL
												]?.resumeDetails?.resumeLink
										  }`
										: ""
								}`
						  )
						: job?.external_job_url,
					"_blank"
				);
			}
		} else {
			try {
				setIsLoadingJobApply(true);
				const jobApplicationResponse = await applyJob(
					candidateProfileData?.userId,
					job?.id
				);
				if (jobApplicationResponse?.status === 200) {
					import("utils/Mixpanel").then((Mixpanel) =>
						Mixpanel.default.track("Web Job Application Successful", {
							page: getUrlPath(),
							"Job ID": job.id,
							JobTitle: job?.title,
							area: job?.address?.area,
							city: job?.address?.city?.name,
							maxSalary: job?.max_salary,
							minSalary: job?.min_salary,
							"Job Board Type": job?.is_external_job
								? "Non Apna Job"
								: "Apna Job",
							earning_potential: job?.earning_potential,
							is_wfh: job?.is_wfh,
							Job_company_name: job?.organization?.name,
							// source: router.query.search
							// 	? "Job Search Web"
							// 	: "Job Feed Web",
							tags_shown: job?.ui_tags?.map((tag) => tag?.text),
							"External Job Type": job?.is_external_job
								? job?.job_lead_type
								: "",
							"Search ID": router?.query?.search
								? localStorage.getItem(
										LOCAL_STORAGE_KEYS.SEARCH_SESSION_ID
								  )
								: "",
							Source: router?.query?.source,
							...moduleTrackData,
						})
					);
					// Get updated appliedJobDetails object
					const { data: privateJobDetails } = await getPrivateJobDetailsV7(
						job?.id?.toString()
					);
					setPostApplicationJobDetails(privateJobDetails);
					// Fetch post success screen data - Post application
					const { data } = await getECCSuccessScreen(job?.id?.toString());
					setPostApplicationEccScreenData(data?.response);
					await registerJobApplicationOnWeb();
					// Set application in LS to mark the job as applied on job listing.
					setJobAsAppliedInLS(job?.id);
					handleIneligibleModalClose();
					setIsLoadingJobApply(false);
					setIsJobApplicationSuccess(true);
					handleApplicationStatusScreenOpen();
				} else {
					import("utils/Mixpanel").then((Mixpanel) =>
						Mixpanel.default.track("Web Job Application Failure", {
							"Job ID": job?.id,
							Score: (appliedJobDetails as any)?.candidateScore,
						})
					);
				}
			} catch (e) {
				console.error("Error applying to job: ", e);
				if (
					e.response.status === 400 &&
					e.response.status !== JOB_STATUS.ACTIVE
				) {
					setJobExpiredResponseData(e.response.data.data);
					setIsExpiredJobModalOpen(true);
					setIsLoadingJobApply(false);
					handleIneligibleModalClose();
				}
			}
		}
	}, [candidateProfileData]);
	const onApplyJob = useCallback(async () => {
		sessionStorage.removeItem("jobApplicationBeforeLoginTriggered");

		if (candidateProfileLoading) {
			return;
		}
		if (!isCandidateEligible && isBulkJob) {
			handleApplicationStatusScreenOpen();
			return;
		}
		if (!isCandidateEligible && !isBulkJob && isRHRUser()) {
			handleApplyJob();
			return;
		}
		if (!isCandidateEligible && !isExternalJob) {
			handleIneligibleModalOpen();
			return;
		}
		handleApplyJob();
	}, [
		candidateProfileData,
		candidateProfileLoading,
		isCandidateEligible,
		setIsJobApplicationSuccess,
		candidateJobApplicationCount,
	]);

	const isJobApplied = useMemo(() => {
		if (!isAppliedJobDetailsLoading && !appliedJobError) {
			if (isJobApplicationSuccess) return isJobApplicationSuccess;
			return (appliedJobDetails as any)?.isJobApplied;
		}
		return isJobApplicationSuccess;
	}, [
		isJobApplicationSuccess,
		appliedJobDetails,
		isAppliedJobDetailsLoading,
		appliedJobError,
	]);

	const isCandidateOnboardingCompleted = useMemo(
		() =>
			isCandidateOnboardingLoading
				? false
				: (candidateOnboardingDetails as any)?.isCandidateOnboardingCompleted,
		[candidateOnboardingDetails, isCandidateOnboardingLoading]
	);

	// const { value: userInfoInStorage } = useLocalStorage(
	// 	LOCAL_STORAGE_KEYS.USER_NAME_NUMBER_INFO
	// );

	const { setCitySearchObject, setExperienceSearchObject, isDesktopSearchExpanded } =
		useJobFeedStore();

	const isDesktopView = useIsDesktop();

	const {
		data: jobDetails,
		isLoading: isJobDetailsLoading,
		isLoadingError: isJobDetailsLoadingError,
	} = useJobDetails(candidateProfileData?.phoneNumber);

	/* 
	 This effect updates the useJobFeedStore based on the user's default city and experience preferences
	 This ensures that the search component is prefilled with these values when expanded.
	*/
	useEffect(() => {
		if (isDesktopSearchExpanded) {
			if (!isJobDetailsLoading && !isJobDetailsLoadingError && jobDetails) {
				const citySearch =
					jobDetails?.[SECTION_MAP.PROFILE_EDITOR]?.location_preference
						?.default_location?.display_name;

				// TODO: fix default location prefill value

				if (citySearch) {
					setCitySearchObject({
						name: citySearch,
					});
				}
			}

			if (
				!candidateProfileLoading &&
				!isCandidateDetailsLoadingError &&
				candidateProfileData
			) {
				const experienceSearch = candidateProfileData?.experienceData;
				if (experienceSearch) {
					setExperienceSearchObject(experienceSearch);
				}
			}
		}
	}, [
		isJobDetailsLoading,
		isJobDetailsLoadingError,
		jobDetails,
		candidateProfileLoading,
		isCandidateDetailsLoadingError,
		candidateProfileData,
		isDesktopSearchExpanded,
	]);

	// const { showWebToAppOverlay, setShowWebToAppOverlay } = useWebToAppBanner();
	// const bannerTrackingEvent = (eventName) => {
	// 	import("utils/Mixpanel").then((Mixpanel) =>
	// 		Mixpanel.default.track(eventName, {
	// 			Source: pageName,
	// 			Section: "Web To App Banner",
	// 			page: getUrlPath(),
	// 			city: jobCity,
	// 			category: category?.type,
	// 			"Job Title": job?.title,
	// 			area: job?.address?.area,
	// 		})
	// 	);
	// };

	// useEffect(() => {
	// 	if (openModal) {
	// 		setShowWebToAppOverlay(false);
	// 		return;
	// 	}
	// 	if (showWebToAppOverlay) {
	// 		bannerTrackingEvent("Web to App Banner Shown");
	// 		onWebToAppBannerTimeout();
	// 	}
	// }, [showWebToAppOverlay]);

	useEffect(() => {
		const jobIdBeforeLogin = sessionStorage.getItem(
			"jobApplicationBeforeLoginTriggered"
		);
		/**
		 * Once the user logs in and he stays in this page, we need to check the application flow doesn't start unless
		 * all the required data is not fetched from server.
		 */
		if (
			candidateProfileLoading ||
			isAppliedJobDetailsLoading ||
			isCandidateOnboardingLoading ||
			isCandidateJobApplicationDetailsLoading
		)
			return;
		if (isUserLoggedIn() && jobIdBeforeLogin === job?.id?.toString()) {
			if (
				!isJobApplied &&
				isCandidateOnboardingCompleted &&
				!isExternalJobApplied
			) {
				onApplyJob();
			}
		}
	}, [
		isUserLoggedIn(),
		isJobApplied,
		isCandidateOnboardingCompleted,
		isExternalJobApplied,
		onApplyJob,
		candidateProfileLoading,
		isAppliedJobDetailsLoading,
		isCandidateOnboardingLoading,
		isCandidateJobApplicationDetailsLoading,
	]);

	// const trackMPEvents = async () => {
	// 	const { default: Mixpanel } = await import("utils/Mixpanel");
	// 	if (openSuccessModal) {
	// 		Mixpanel.track("Application sent successful screen shown", {
	// 			Eligible: "Yes",
	// 		});
	// 	} else if (openFailureModal) {
	// 		Mixpanel.track("Application sent successful screen shown", {
	// 			Eligible: "No",
	// 		});
	// 	} else if (openFirstJobApplyModal) {
	// 		Mixpanel.track("Job Apply Confirmation Screen Shown");
	// 	} else if (openApplicationLimitModal) {
	// 		Mixpanel.track("Application Limit Screen Shown");
	// 	}
	// };

	// useEffect(() => {
	// 	trackMPEvents();
	// }, [
	// 	openSuccessModal,
	// 	openFailureModal,
	// 	openFirstJobApplyModal,
	// 	openApplicationLimitModal,
	// ]);

	// const onWebToAppBannerTimeout = () => {
	// 	setTimeout(() => {
	// 		if (
	// 			showWebToAppOverlay &&
	// 			localStorage.getItem(WEB_TO_APP_BANNER_SHOWN) !== "true"
	// 		) {
	// 			setShowWebToAppOverlay(false);
	// 			localStorage.setItem(WEB_TO_APP_BANNER_SHOWN, "true");
	// 			bannerTrackingEvent("Web to app banner closed - timeout");
	// 		}
	// 	}, 70000);
	// };
	// const jobIdQueryParam = useMemo(() => {
	// 	if (router?.pathname === "/job/[...job]") {
	// 		const jobParsed =
	// 			router.query?.job?.[router.query?.job?.length - 1].split("-");
	// 		const jobId = jobParsed[jobParsed?.length - 1];
	// 		return `&&jobId=${jobId}`;
	// 	}
	// 	return null;
	// }, [router.pathname]);
	// eslint-disable-next-line consistent-return
	const getExperience = () => {
		if (job.min_experience > 0) {
			if (job.max_experience <= 1) {
				return "Experience: 1 year";
			}
			if (job.max_experience <= 2) {
				return "Experience: 2 years";
			}
			if (job.max_experience > 0) {
				return `Experience: ${job.min_experience} - ${job.max_experience} years`;
			}
			return `Experience: ${job.min_experience} years`;
		}

		if (job.min_experience === 0 && job.max_experience > 0) {
			return `Experience: ${job.max_experience} years`;
		}
	};

	const metaTitleInternal = `${job?.title} in ${capitalizeFirstLetter(jobCompany)}${
		jobCity && jobArea ? `, ${jobArea}, ${jobCity}` : ""
	}${hasJobExpired ? " - Position Filled" : ""}`;
	const metaTitleInternal2 = `${job?.title} in ${capitalizeFirstLetter(jobCompany)}
	| Apply for ${job?.title} in ${capitalizeFirstLetter(jobCompany)} ${
		job?.min_salary && job?.max_salary
			? `Salary upto ${job.min_salary.toLocaleString()} - ${job.max_salary.toLocaleString()} ₹`
			: ""
	} ${hasJobExpired ? " - Position Filled" : ""}`;

	const metaTitleForExternal1 = `View & Apply for ${
		job?.title
	} in ${capitalizeFirstLetter(jobCompany)}`;
	const metaTitleForExternal2 = `Apply for ${job?.title} in  ${capitalizeFirstLetter(
		jobCompany
	)}`;
	const metaTitleForExternal3 = `${job?.title} in  ${capitalizeFirstLetter(
		jobCompany
	)}`;
	const metaDescription1 = `${today} - Apply for ${
		job?.title
	} at ${capitalizeFirstLetter(jobCompany.trim())}! ${
		job?.min_salary && job?.max_salary
			? `Salary upto ${job.min_salary.toLocaleString()} - ${job.max_salary.toLocaleString()} ₹`
			: ""
	}`;

	const metaDescription2 = `${today} - Earn up to ${job.min_salary.toLocaleString()} - ${job.max_salary.toLocaleString()} ₹ as a ${
		job.title
	}! Apply now!`;

	const metaTitle = isExternalJob
		? metaTitleForExternal1.length > 48
			? metaTitleForExternal2.length > 48
				? metaTitleForExternal3
				: metaTitleForExternal2
			: metaTitleForExternal1
		: metaTitleInternal.length <= 62
		? metaTitleInternal
		: metaTitleInternal2.length > 62
		? metaTitleInternal
		: metaTitleInternal2;

	const metaDescription = isExternalJob
		? `View and apply for ${job.title} in ${capitalizeFirstLetter(jobCompany)}. ${
				jobCity
					? `Explore ${job.title} openings in ${jobCity} now.`
					: `Explore ${job.title} openings now.`
		  } `
		: !hasJobExpired
		? job?.min_salary && job?.max_salary
			? metaDescription1.length > 160
				? metaDescription2
				: metaDescription1
			: `Apply for ${job.title} job in ${capitalizeFirstLetter(jobCompany)} ${
					jobCity && jobArea ? ` at ${jobArea}, ${jobCity}` : ""
			  } on apna app.`
		: `The position for ${job?.title} at ${
				jobCompany ? `in ${capitalizeFirstLetter(jobCompany)}` : ""
		  } has been filled. Check our job listing for more such opportunities`;

	useEffect(() => {
		// eslint-disable-next-line camelcase
		// job && job.id && loadSimilarJobs(job.id);
		job &&
			job.id &&
			import("utils/Mixpanel").then((Mixpanel) => {
				Mixpanel.default.track("Page View", {
					"Page URL": typeof window !== "undefined" && window.location.href,
					page: getUrlPath(),
					Source: pageName,
					id: job.id,
					status: job.status,
					area: job.area_slug,
					city: job.city_slug,
					category: job.category_slug,
					title: job.title,
					min_salary: job.min_salary,
					max_salary: job.max_salary,
					no_of_openings: job.no_of_openings,
				});
			});

		TagManagerUtils.addDataLayer({
			job: {
				id: job.id,
				status: job.status,
				title: job.title,
				min_salary: job.min_salary,
				max_salary: job.max_salary,
				no_of_openings: job.no_of_openings,
				experience_level: job.experience_level,
			},
			area: jobArea,
			city: jobCity,
			category: category?.type,
			workFromHome: job.is_wfh,
			partTime: job.is_part_time,
			womenJob: job.gender === "f",
			freshersJob: job.experience_level === "f",
			Source: pageName,
		});
	}, []);
	useEffect(() => {
		import("utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Jod Details Fetched Web", {
				section: mxpTrackSection.JOB_CARD,
				page: getUrlPath(),
				"Job ID": job?.id,
				JobTitle: job?.title,
				// category: jobCategory?.slug,
				area: job?.address?.area,
				city: job?.address?.city?.name,
				maxSalary: job?.max_salary,
				minSalary: job?.min_salary,
				"Job Board Type": job?.is_external_job ? "Non Apna Job" : "Apna Job",
				earning_potential: job?.earning_potential,
				is_wfh: job?.is_wfh,
				Job_company_name: job?.organization?.name,
				// source: router.query.search ? "Job Search Web" : "Job Feed web",
				tags_shown: job?.ui_tags?.map((tag) => tag?.text),
				"External Job Type": job?.is_external_job ? job?.job_lead_type : "",
			});
		});
	}, [job?.id]);

	const isExpiredJob = job.status !== JOB_STATUS.ACTIVE;
	const hasAppliedJobOnWeb = useMemo(
		() =>
			isCandidateJobApplicationDetailsLoading
				? false
				: !!(candidateJobApplicationDetails as any)?.jobApplicationCount,
		[candidateJobApplicationDetails, isCandidateJobApplicationDetailsLoading]
	);
	// const getDeepLinkUrl = async () =>
	// 	createBranchDeepLink({
	// 		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.webToAppBanner,
	// 		section: "Web To App Banner",
	// 		pageType: pageName,
	// 		notificationType: "JOB_DETAIL",
	// 		branchStage: pageName,
	// 		branchCampaign: "Job Link",
	// 		channel: "Job Link",
	// 		id: "job-deep-link",
	// 		branchProps: {
	// 			job_id: job.id,
	// 			city: jobCity,
	// 			category: category.type,
	// 			area: job?.address?.area,
	// 		},
	// 		router,
	// 	});

	// const openInAPP = async () => {
	// 	const deepLinkUrl = await getDeepLinkUrl();
	// 	window.open(deepLinkUrl, "_self");
	// 	setShowWebToAppOverlay(false);
	// 	localStorage.setItem(WEB_TO_APP_BANNER_SHOWN, "true");
	// };

	const commonTrackingObj = {
		jobId: job?.id,
		Source: pageName,
		"Job Title": job?.title,
		"Min Salary": job?.min_salary,
		"Max Salary": job.max_salary,
		Area: job?.address?.area,
		City: job?.address?.city?.name,
		page: getUrlPath(),
		category: job?.category_slug,
		userPlatform: USER_PLATFORM.apna,
	};

	// const onCloseModalClickHandler = (e) => {
	// 	e && e.stopPropagation();
	// 	setOpenModal(false);
	// 	localStorage.setItem(OTHER_BANNER_OPEN, "false");
	// 	if (localStorage.getItem(WEB_TO_APP_BANNER_SHOWN) !== "true") {
	// 		// If Web to App Banner is not shown and Lead is captured
	// 		// then open Web to App Banner after 30 seconds
	// 		if (localStorage.getItem(LOCAL_STORAGE_KEYS.USER_NAME_NUMBER_INFO)) {
	// 			setTimeout(() => {
	// 				if (localStorage.getItem(OTHER_BANNER_OPEN) !== "true") {
	// 					setShowWebToAppOverlay(true);
	// 				}
	// 			}, 30000);
	// 			// eslint-disable-next-line @typescript-eslint/brace-style
	// 		}
	// 		// If Web to App Banner is not shown and Lead is also not captured
	// 		// Open Web to App Banner immediately
	// 		else {
	// 			setShowWebToAppOverlay(true);
	// 		}
	// 	}

	// 	const section = "Apply Now";
	// 	const userInfo = userInfoInStorage;

	// 	import("utils/Mixpanel").then((Mixpanel) => {
	// 		Mixpanel.default.track("Job Lead Modal Close", {
	// 			...commonTrackingObj,
	// 			Source: "job_application",
	// 			page: getUrlPath(),
	// 			cta: section,
	// 			...userInfo,
	// 		});
	// 	});
	// };

	const trackingEvent = (eventName, cta, userInfo = {}) => {
		import("utils/Mixpanel").then((Mixpanel) =>
			Mixpanel.default.track(eventName, {
				...commonTrackingObj,
				cta,
				...userInfo,
			})
		);
	};
	const shareWhatsApp = (e) => {
		e.preventDefault();
		e.stopPropagation();
		trackingEvent("Web Job shared click", "Share Job");
		const isMobile = /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
		const whatsAppbaseUrl = `https://${isMobile ? "api" : "web"}.whatsapp.com/send`;
		const shareUrl = `${whatsAppbaseUrl}?text=${encodeURIComponent(
			`${sharetext}\n ${job.public_url}?utm_source=whatsapp&utm_campaign=joblistingpage`
		)}`;
		window.open(shareUrl, "_blank");
	};

	const [downloadAppNowUrl] = useBranchIoLinkGeneration({
		id: null,
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.downloadAppCTA,
		pageType: pageName,
		section: "Call HR Banner",
		custom_utm_medium: PAGE_TYPES.long,
	});

	const downloadAppClick = () => {
		trackOnMixpanel("Download app card clicked", {
			Screen: "Job Details Page Web",
		});
		window.open(downloadAppNowUrl as any, "_blank");
	};
	const trackApplicationsClick = () => {
		downloadAppClick();
		trackOnMixpanel("Track your applications clicked", {
			Screen: "Job Details Web",
		});
	};

	// const handleCtaClose = () => {
	// 	setCtaOpen(false);
	// };

	const handleApplicationStatusScreenOpen = () => {
		setShowApplicationStatusScreen(true);
	};

	const handleApplicationStatusScreenClose = () => {
		setShowApplicationStatusScreen(false);
	};

	// const handleFailureModalOpen = () => {
	// 	setShowIneligibleModal(true);
	// };

	// const handleFailureModalClose = () => {
	// 	setShowIneligibleModal(false);
	// };

	const handleIneligibleModalOpen = () => {
		setShowIneligibleModal(true);
	};

	const handleIneligibleModalClose = () => {
		setShowIneligibleModal(false);
	};

	// const handleFirstJobApplyModalOpen = () => {
	// 	setOpenFirstJobApplyModal(true);
	// };

	// const handleFirstJobApplyModalClose = () => {
	// 	setOpenFirstJobApplyModal(false);
	// };

	// const handleApplicationLimitModalOpen = () => {
	// 	setOpenApplicationLimitModal(true);
	// };

	// const handleApplicationLimitModalClose = () => {
	// 	setOpenApplicationLimitModal(false);
	// };

	// const handleFirstJobApplyPrimaryBtnCTA = async () => {
	// 	const { default: Mixpanel } = await import("utils/Mixpanel");
	// 	Mixpanel.track("Job Apply Confirmation Screen Shown", {
	// 		"CTA clicked": "Apply Now",
	// 	});

	// 	handleFirstJobApplyModalClose();
	// 	onApplyJob();
	// };

	// const redirectToPlayStore = () => {
	// 	handleCtaClose();
	// 	handleApplicationStatusScreenClose();
	// 	window.open(downLoadApnaLink);
	// };

	const redirectToJobFeed = () => {
		const queryObj: any = {};
		if (isUserLoggedIn()) {
			queryObj.c_id = isUserLoggedIn();
		}
		if (isHostLaunchedMicrosite()) {
			queryObj.source = isHostLaunchedMicrosite();
		}
		router.push({ pathname: `/jobs`, query: queryObj });
	};

	const trackApplyClickEvent = async () => {
		const { default: Mixpanel } = await import("utils/Mixpanel");

		Mixpanel.track("Apply Now Button Clicked", {
			page: getUrlPath(),
			"Job ID": job.id,
			JobTitle: job?.title,
			area: job?.address?.area,
			city: job?.address?.city?.name,
			maxSalary: job?.max_salary,
			minSalary: job?.min_salary,
			"Job Board Type": job?.is_external_job ? "Non Apna Job" : "Apna Job",
			earning_potential: job?.earning_potential,
			is_wfh: job?.is_wfh,
			Job_company_name: job?.organization?.name,
			tags_shown: job?.ui_tags?.map((tag) => tag?.text),
			"External Job Type": job?.is_external_job ? job?.job_lead_type : "",
			"Search ID": router?.query?.search
				? localStorage.getItem(LOCAL_STORAGE_KEYS.SEARCH_SESSION_ID)
				: "",
			Source: router?.query?.source,
			...moduleTrackData,
		});
	};

	/* For non-logged-in users, we redirect them to a branch link. The branch will
	 * redirect the user to Android app if its present, if not, the user will be
	 * redirected via branch to /candidate-login page along with jobId and returnTo parameters.
	 * Note: jobId is required for web, job_id is required for Android. Both should be present. */
	const nonLoggedInApplyLink = `${config.applyNowBranchBaseUrl}?jobId=${job?.id}&returnTo=${router.asPath}&job_id=${job?.id}`;

	/* For logged-in users, we do an in-app redirect to login page */

	useEffect(() => {
		const fetchConfig = async () => {
			const response = await fetchCandidateConfig();
			setLoggedInApplyLink(
				`/${response.data.targetOnboardingRootRoute}?jobId=${job?.id}&returnTo=${
					router.asPath
				}${isRHRUser() ? "&flowType=rhr" : ""}`
			);
		};
		fetchConfig();
	}, []);

	const applyLink = useMemo(
		() =>
			isUserLoggedIn()
				? !isJobApplied && !isCandidateOnboardingCompleted && loggedInApplyLink
				: nonLoggedInApplyLink,
		[loggedInApplyLink, isUserLoggedIn()]
	);

	/*
		For external jobs, we want to track if user has clicked on apply button.
			For logged in user:
				When apply button is clicked, we open external job link in new tab. When user closes the new tab,
				we want to show a feedback modal asking if user applied for the job or not. 
			For logged out user:
				On apply button click, user is taken to login screen in blind hr. On success, we open new tab with external job link.
				In original tab, we revert back to job details page. 
				In this case, we want to show feedback modal when user comes back to this page. Tracking is done by storing
				apply button click state in local storage.
		On submitting a value for feedback, we clear local storage.
	*/
	const getIsApplyButtonClicked = () => {
		const value = localStorage?.getItem(IS_APPLY_BUTTON_CLICKED_EXTERNAL_JOB);
		return value;
	};
	const setIsApplyButtonClicked = (value: string, jobId: number) => {
		if (value === "true")
			localStorage?.setItem(IS_APPLY_BUTTON_CLICKED_EXTERNAL_JOB, jobId.toString());
		else localStorage.removeItem(IS_APPLY_BUTTON_CLICKED_EXTERNAL_JOB);
	};
	/**
	 * This case is implemented only for cases when user arrives to this page from
	 * auto-login branch link, and for the gap between redirection start and end we want to show
	 * the loader instead of the page content.
	 */
	if (
		// eslint-disable-next-line no-underscore-dangle
		(router?.query?._branch_referrer || router.query?._branch_match_id) &&
		!isUserLoggedIn()
	) {
		return (
			<div className="flex h-[100vh] w-full items-center justify-center">
				<CircularProgress style={{ marginBottom: "31px", color: "#1F8268" }} />
			</div>
		);
	}
	const renderApplyButtonText = () => {
		if (isLoadingJobApply || isAppliedJobDetailsLoading) {
			return (
				<div className="flex w-full items-center justify-center md:w-[100px]">
					<CircularProgress color="inherit" size={25} />
				</div>
			);
		}
		if (!isJobApplied && isExternalJob) {
			return (
				<div className="flex w-full cursor-pointer items-center justify-center gap-[8px]">
					{externalJobApplyCTA(job)}
				</div>
			);
		}
		if (isJobApplied) {
			return <p className="m-0 whitespace-nowrap text-sm">Applied</p>;
		}
		if (!isJobApplied && !isExternalJob) {
			if (isWalkInJob) {
				return (
					<div className="flex w-full cursor-pointer items-center justify-center gap-[8px]">
						Register for walk in
					</div>
				);
			}
			return <div className="w-full">Apply for job</div>;
		}
		return "";
	};
	const handleApplyButtonClick = () => {
		// Desktop and non logged in user
		if (!isUserLoggedIn() && isDesktopView) {
			trackApplyClickEvent();
			sessionStorage.setItem(
				"jobApplicationBeforeLoginTriggered",
				job.id.toString()
			);
			startAuth(AUTH_SOURCE.JOB_APPLY);
			return;
		}

		// for Mweb non logged out user
		if (!isUserLoggedIn() && !isDesktopView) {
			if (applyLink) {
				trackApplyClickEvent();
				sessionStorage.setItem(
					"jobApplicationBeforeLoginTriggered",
					job.id.toString()
				);
				startAuth(AUTH_SOURCE.JOB_APPLY);
			}
			return;
		}

		// For logged in and non enriched user
		if (isUserLoggedIn() && !isCandidateOnboardingCompleted) {
			if (applyLink) {
				setShowRedirectingElement(true);
				trackApplyClickEvent();
				sessionStorage.setItem(
					"jobApplicationBeforeLoginTriggered",
					job.id.toString()
				);
				setTimeout(() => {
					setShowRedirectingElement(false);
					window.open(applyLink, "_self");
				}, 4000);
				return;
			}
		}

		if (
			!isJobApplied &&
			isCandidateOnboardingCompleted &&
			!isExternalJobApplied &&
			!isAppliedJobDetailsLoading
		) {
			trackApplyClickEvent();
			onApplyJob();
		}
	};

	const jobApplicationMode = appliedJobDetails?.job_application_mode;
	const handleCandidateLoginClick = () => {
		const screenType = "Job Detail Page";

		startAuth();
		trackOnMixpanel("Login card clicked", {
			Screen: "Job Detail Page Web",
		});

		import("../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Candidate login", {
				page: getUrlPath(),
				Section: "Header",
				actionType: "Redirection",
				cta: "Candidate Website Login",
				Screen: screenType,
			});
		});
	};

	const renderApplyButtonSection = () => {
		if (jobApplicationMode?.mode === "throttled") {
			return "";
		}
		if (
			job?.status === JOB_STATUS.ACTIVE &&
			(jobApplicationMode || !isUserLoggedIn())
		) {
			const buttonJsx = () => (
				<div
					className={clsx(
						"cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[8px] text-center font-semibold text-white",
						{
							"bg-[#B8B0B9] opacity-50":
								isJobApplied || (isExternalJob && isExternalJobApplied),
						}
					)}
					onClick={handleApplyButtonClick}
				>
					{!isExternalJobApplied && renderApplyButtonText()}
					{isExternalJob && isExternalJobApplied && <>Application sent</>}
				</div>
			);
			return <>{buttonJsx()}</>;
		}

		const buttonJsx = () => (
			<div
				className={clsx(
					"w-full rounded border border-solid bg-[#1F8268] px-[16px] py-[8px] text-center font-semibold text-white",
					{
						"opacity-50":
							isJobApplied || (isExternalJob && isExternalJobApplied),
					}
				)}
				onClick={handleApplyButtonClick}
			>
				{!isExternalJobApplied && renderApplyButtonText()}
				{isExternalJob && isExternalJobApplied && <>Application sent</>}
			</div>
		);
		return <>{buttonJsx()}</>;
	};

	const handleCloseEpiredJobModal = () => {
		setIsExpiredJobModalOpen(false);
	};

	return (
		<NewThemedLayout availableVendor={vendor}>
			<LayoutV2
				title={metaTitle}
				metaTitle={metaTitle}
				metaDescription={metaDescription}
				ogImageUrl={jobOGImageUrl}
				ogUrl={jobOGUrl}
				source={pageName}
				slug={slug}
				hideBottomCTA
				activePage="job"
				staticFooter={false}
				dynamicFooterLinks={jobDetailfooterlinks}
				availableVendor={vendor}
				disableIndexing={hasJobExpired}
				removeMarginFromFooter
			>
				<Head>
					{jobSchema && (
						<>
							<script
								type="application/ld+json"
								dangerouslySetInnerHTML={{
									__html: jobSchema,
								}}
							/>
							{faqSchema !== null && (
								<script
									type="application/ld+json"
									dangerouslySetInnerHTML={{
										__html: faqSchema,
									}}
								/>
							)}
						</>
					)}
					{job.status !== JOB_STATUS.ACTIVE && (
						<meta name="robots" content="noindex, follow" />
					)}
				</Head>
				<JobExpiredModal
					isOpen={isExpiredJobModalOpen}
					modalData={jobExpiredResponseData}
					handleClose={handleCloseEpiredJobModal}
				/>
				<div className="relative bg-[#F4F2F6]">
					{/* Desktop Sticky bar with company details and Apply/Share button.  */}
					<div
						className={clsx(
							"hidden w-full items-center justify-center bg-white p-[16px] shadow",
							{
								"sticky top-[79px] z-[5] md:flex":
									showStickyJobDetailsBar,
							}
						)}
					>
						<div className="space-between flex w-full max-w-[1040px] items-center">
							<div className="col-span-4 mb-[4px] flex w-full gap-[12px]">
								{job?.organization?.logo_url ? (
									<div className="h-[48px] w-[48px]">
										<Image
											height={48}
											width={48}
											layout="fixed"
											src={job?.organization?.logo_url}
											className="rounded object-contain"
											quality={100}
											unoptimized
										/>
									</div>
								) : (
									<div className="h-[48px] w-[48px] rounded bg-[#F2F2F3] [&>svg]:h-[48px] [&>svg]:w-[48px]">
										<CompanyAddressIcon />
									</div>
								)}
								<div>
									<p className="m-0 text-xl font-bold text-[#190A28]">
										{job?.title}
									</p>
									<p className="m-0 text-sm text-[#8C8594] md:text-md">
										{job?.organization?.name}
									</p>
								</div>
							</div>
							{!isExpiredJob && (
								<div className="flex w-full items-center justify-end gap-[28px] md:text-sm">
									<div
										className="h-[24px] w-[24px] cursor-pointer [&>svg]:h-[24px] [&>svg]:w-[24px]"
										onClick={shareWhatsApp}
									>
										<ShareIcon />
									</div>
									<div>{renderApplyButtonSection()}</div>
								</div>
							)}
						</div>
					</div>
					{/* Main content */}
					<div className="flex w-full max-w-5xl flex-col md:mx-auto md:mt-[24px] md:flex-row md:justify-center md:gap-[16px] md:pb-6">
						{/* Left Section */}
						<div className="md:w-full md:max-w-[690px] md:space-y-[12px]">
							<div ref={jobDetailsCardRef}>
								<JobDetailsCard
									jobDetails={job}
									isJobApplied={isJobApplied}
									applyLink={applyLink}
									jobApplicationMode={
										appliedJobDetails?.job_application_mode
									}
									isExternalJobApplied={isExternalJobApplied}
									pageName={pageName}
									isLoadingJobApply={isLoadingJobApply}
									handleApplyButtonClick={handleApplyButtonClick}
									isAppliedJobDetailsLoading={
										isAppliedJobDetailsLoading
									}
								/>
							</div>
							{jobApplicationMode?.mode === "throttled" &&
								!isMobileView && (
									<div className="flex items-center gap-[8px] rounded-lg bg-[#FFF9DB] px-[12px] py-[8px]">
										<InfoIconOutline />
										<p className="m-0 text-sm text-[#AA4900]">
											{jobApplicationMode?.message}
										</p>
									</div>
								)}
							{isWalkInJob && !isMobileView && (
								<div className="flex items-center gap-[8px] rounded-lg bg-[#EBF3FE] px-[12px] py-[8px]">
									<InfoIcon fill="#003C96" size={16} />
									<p className="m-0 text-[16px] leading-[24px] text-[#003C96]">
										Read walk-in details before you register
									</p>
								</div>
							)}
							<JobDetailsSection
								jobDetails={job}
								jobDescription={jobDescription}
								shortJobDescription={shortJobDescription}
								similarJobs={similarJobs}
								category={job?.category}
								similarJobsJoading={similarJobsJoading}
								isCandidateEligible={isCandidateEligible}
								isJobApplied={isJobApplied}
								handleWalkInNudgeClick={() =>
									setShowWalkInEligibleBs(true)
								}
								jobDescriptionTemplate={jobDescriptionTemplate}
							/>
							{!isMobileView && !isExternalJob && (
								<div className="rounded-0 w-full bg-white p-[24px] md:max-w-[690px] md:overflow-hidden md:rounded-xl md:border md:border-solid md:bg-white">
									<div className="flex justify-between">
										<div className="flex items-center justify-between">
											<div className="text-[20px] font-bold">
												FAQs about this job
											</div>
										</div>
										{!isMobileView && (
											<div>
												{showQNASection ? (
													<p
														onClick={() =>
															setShowQNASection(false)
														}
														className="align-center m-0 flex cursor-pointer items-center justify-center text-[14px] font-semibold leading-[20px] text-[#1F8268]"
													>
														Hide all
														<DownArrow className="ml-[4px] h-[16px] w-[16px] rotate-180 fill-[#1F8268]" />
													</p>
												) : (
													<p
														onClick={() =>
															setShowQNASection(true)
														}
														className="align-center m-0 flex cursor-pointer items-center justify-center text-[14px] font-semibold leading-[20px] text-[#1F8268]"
													>
														Show all
														<DownArrow className="ml-[4px] h-[16px] w-[16px] fill-[#1F8268]" />
													</p>
												)}
											</div>
										)}
									</div>
									{showQNASection && (
										<FAQs faqs={getJobsQNA(jobDescriptionTemplate)} />
									)}
								</div>
							)}
						</div>
						{/* Right Section */}
						<div
							className="mb-[16px] flex h-full w-full flex-col space-y-[12px] md:mb-0 md:w-[335px]"
							key="banner-section"
						>
							{/* Banner 1 */}
							{isUserLoggedIn() && !isMobileView && (
								<div className="relative mx-[12px] md:m-0 md:p-0">
									<img
										src="https://cdn.apna.co/cloudinary/employer-dashboard-images/Logged%20in.png"
										alt=""
										className="h-auto w-auto"
									/>
								</div>
							)}
							{!isUserLoggedIn() && !isMobileView && (
								<div className="relative mx-[12px] md:m-0 md:p-0">
									<img
										src="https://cdn.apna.co/cloudinary/employer-dashboard-images/Logged%20out.png"
										alt=""
										className="h-auto w-auto"
									/>
								</div>
							)}
							{/* Similar Jobs Section */}
							{!isMobileView && (
								<SimilarJobsSection
									similarJobs={similarJobs}
									category={job?.category}
									similarJobsJoading={similarJobsJoading}
								/>
							)}
							{/* Banner 2 */}

							{isUserLoggedIn() && !hasAppliedJobOnWeb && (
								<div
									className="relative mx-[12px] cursor-pointer md:m-0 md:p-0"
									onClick={downloadAppClick}
								>
									{!isMobileView ? (
										<img
											src="https://cdn.apna.co/apna-job-feed-details-banners/Job%20Details%20-%20Desktop/Download%20App.png"
											alt=""
											className="h-auto w-auto"
										/>
									) : (
										<img
											src="https://cdn.apna.co/apna-job-feed-details-banners/Job%20Details%20-%20Mobile/Download%20App.png"
											alt=""
											className="h-auto w-auto"
										/>
									)}
								</div>
							)}
							{isUserLoggedIn() && hasAppliedJobOnWeb && (
								<div
									className="relative mx-[12px] cursor-pointer md:m-0 md:p-0"
									onClick={trackApplicationsClick}
								>
									<img
										src="https://cdn.apna.co/apna-job-feed-details-banners/New%20-%20Track%20Applications/Job%20details%20-%20Desktop%20-%20Track%20Applications.png"
										alt=""
										className="h-auto w-auto"
									/>
								</div>
							)}
							{!isUserLoggedIn() && !isMobileView && (
								<div
									className="relative mx-[12px] mt-[12px] cursor-pointer md:m-0 md:p-0"
									onClick={handleCandidateLoginClick}
								>
									<img
										src="https://cdn.apna.co/apna-job-feed-details-banners/Job%20Details%20-%20Desktop/Login.png"
										alt=""
										className="h-auto w-auto"
									/>
								</div>
							)}
						</div>
					</div>
				</div>
				{/* {!isInternationalJob && (
					<div className="flex w-full items-center justify-center">
						<div className="w-full bg-[#f4f2f6] md:bg-white">
							{topCompanies?.length > 0 && (
								<TopCompanies
									topCompanies={topCompanies}
									citySlug={job?.city_slug}
								/>
							)}
						</div>
					</div>
				)} */}
				{/* Mobile apply button */}
				{!isExpiredJob && jobApplicationMode?.mode !== "throttled" && (
					<div
						className="fixed bottom-0 left-0 w-full border border-solid bg-white md:hidden"
						key="button section"
					>
						{isWalkInJob && isMobileView && (
							<div className="flex w-full items-center justify-center gap-[4px] bg-[#EBF3FE] p-[8px]">
								<InfoIcon fill="#003C96" size={16} />
								<p className="m-0 text-xs leading-[16px] text-[#003C96]">
									Read walk-in details before you register
								</p>
							</div>
						)}
						<div className="flex w-full items-center gap-[32px] p-[16px] md:text-sm">
							<div
								className="h-[24px] w-[24px] cursor-pointer [&>svg]:h-[24px] [&>svg]:w-[24px]"
								onClick={shareWhatsApp}
							>
								<ShareIcon />
							</div>
							<div className="w-full">{renderApplyButtonSection()}</div>
						</div>
					</div>
				)}
				{isExpiredJob && isMobileView && (
					<div className="fixed bottom-0 left-0 w-full">
						<div className="flex items-center gap-[8px] bg-[#FBECED] p-[12px]">
							<InfoIcon fill="#CC0000" size={24} />
							<p className="m-0 text-xs leading-[16px] text-[#CC0000]">
								This job has expired
							</p>
						</div>
					</div>
				)}
				{jobApplicationMode?.mode === "throttled" && isMobileView && (
					<div className="fixed bottom-0 left-0 w-full">
						<div className="flex items-center gap-[8px] bg-[#FFF9DB] p-[12px]">
							<ClockIcon />
							<p className="m-0 text-xs leading-[16px] text-[#190A28]">
								{jobApplicationMode?.message}
							</p>
						</div>
					</div>
				)}

				{/* <MobileWebToAppBanner>
					{showWebToAppOverlay && (
						<WebToAppBanner
							showOverlay={showWebToAppOverlay}
							onClose={(e) => {
								setShowWebToAppOverlay(false);
								localStorage.setItem(WEB_TO_APP_BANNER_SHOWN, "true");
								bannerTrackingEvent("Continue in Browser Clicked");
								e.stopPropagation();
							}}
							description={
								<>
									<Title>{`Call HR on Apna app to get ${job.title} Job`}</Title>
									<DescriptionContainer>
										<DescriptionWrapper>
											<TickIcon />
											<Description>
												Improve your job search
											</Description>
										</DescriptionWrapper>
										<DescriptionWrapper>
											<TickIcon />
											<Description>Get alerts</Description>
										</DescriptionWrapper>
									</DescriptionContainer>
								</>
							}
							onBackDropClick={() => {
								setShowWebToAppOverlay(false);
								localStorage.setItem(WEB_TO_APP_BANNER_SHOWN, "true");
								bannerTrackingEvent(
									"Web to app banner closed - out click"
								);
							}}
							imageSrc="/cloudinary/profile_page_images/Call-HR.jpg"
							onCTAClick={() => {
								bannerTrackingEvent("App Open Clicked");
								openInAPP();
							}}
						/>
					)}
				</MobileWebToAppBanner> */}
				{/* TODO - integrate these ModalJobApplication-Modals */}
				{/* <div onClick={handleCtaOpen}>Click here</div> */}
			</LayoutV2>
			{/* {openModal && (
				<Modal
					isOpen={openModal}
					onRequestClose={onCloseModalClickHandler}
					shouldCloseOnOverlayClick={false}
				>
					{job && (
						<JobApplyContent
							jobDetail={job}
							toggleModal={onCloseModalClickHandler}
							source={pageName}
							jobCategory={category}
							cta="Apply Now"
						/>
					)}
				</Modal>
			)} */}
			{/* Post apply screen */}
			<ApplicationStatusScreen
				showApplicationStatusScreen={showApplicationStatusScreen}
				job={job}
				similarJobs={similarJobs}
				isCandidateEligible={isCandidateEligible}
				handleClose={async () => {
					handleApplicationStatusScreenClose();
				}}
				requirementsData={appliedJobDetails?.job_requirement_mismatch || {}}
				isJobApplied={isJobApplied}
				redirectToJobFeed={redirectToJobFeed}
				isContactHREnabled={appliedJobDetails?.working_hour_info?.allowed}
				eccScreenData={postApplicationEccScreenData}
			/>
			{/* Failure Modal */}
			{/* Not eligible screen for non RHR users */}
			<InEligibleJobNudge
				isCTACardOpen={showIneligibleModal}
				handleCloseClick={() => {
					trackOnMixpanel(WEB_JOB_APPLICATION_INELIGIBLE_SCREEN_CTA_CLICKED, {
						"CTA Clicked": "Kill",
						"Deal Breaker Score": deal_breaker_score,
						"Job Requirements": jobRequirementsMPData,
						...commonTrackEventsJobProperties,
					});
					handleIneligibleModalClose();
				}}
				requirementsData={appliedJobDetails?.job_requirement_mismatch || {}}
				handlePrimaryBtnClick={() => {
					trackOnMixpanel(WEB_JOB_APPLICATION_INELIGIBLE_SCREEN_CTA_CLICKED, {
						"CTA Clicked": "See Other Jobs",
						"Deal Breaker Score": deal_breaker_score,
						"Job Requirements": jobRequirementsMPData,
						...commonTrackEventsJobProperties,
					});
					redirectToJobFeed();
					setShowIneligibleModal(false);
				}}
				handleSecondaryBtnClick={() => {
					trackOnMixpanel(WEB_JOB_APPLICATION_INELIGIBLE_SCREEN_CTA_CLICKED, {
						"CTA Clicked": "Apply Anyway",
						"Deal Breaker Score": deal_breaker_score,
						"Job Requirements": jobRequirementsMPData,
						...commonTrackEventsJobProperties,
					});
					handleApplyJob();
				}}
				handleSecondaryBtnLoading={isLoadingJobApply}
				handleSecondaryBtnDisabled={isLoadingJobApply}
				commonTrackEventsJobProperties={commonTrackEventsJobProperties}
				jobRequirementsMPData={jobRequirementsMPData}
				dealBreakerScore={deal_breaker_score}
				showSecondaryApplyButton={!isCandidateEligible && !isBulkJob}
			/>
			{showRedirectingElement && (
				<RedirectToOnboarding
					open={showRedirectingElement}
					applyLink={applyLink}
				/>
			)}
			<WalkInNudgeModal
				open={isJobApplied && showWalkInEligibleBs}
				handleClose={() => setShowWalkInEligibleBs(false)}
				isCandidateEligible={isCandidateEligible}
				openDownloadAppNudge={() => {
					setShowDowloadAppModal(true);
					setShowWalkInEligibleBs(false);
				}}
				appliedJobDetails={
					postApplicationJobDetails?.is_applied
						? postApplicationJobDetails
						: appliedJobDetails
				}
			/>
			<DownloadAppNudgeModal
				open={showDowloadAppModal}
				handleClose={() => setShowDowloadAppModal(false)}
			/>

			<ExternalJobAppliedFeedbackModal
				job={job}
				isOpen={showExternalJobAppliedFeedbackModal && isUserLoggedIn()}
				handleClose={() => {
					setShowExternalJobAppliedFeedbackModal(false);
					setIsApplyButtonClicked("false", job?.id);
				}}
				commonTrackingObj={commonTrackingObj}
				markExternalJobAsApplied={() => setIsExternalJobApplied(true)}
				moduleTrackData={moduleTrackData}
			/>
		</NewThemedLayout>
	);
};

// const MobileWebToAppBanner = styled.div`
// 	display: block;
// 	position: fixed;
// 	bottom: 0;
// 	z-index: 21;
// 	${bp.md} {
// 		display: none;
// 	}
// `;

// const Title = styled.h3`
// 	margin: 8px 0 0;
// 	font-weight: ${(props) => props.theme.fontWeight.bold};
// 	font-size: 16px;
// 	line-height: 24px;
// 	color: #31445a;
// `;

// const DescriptionContainer = styled.div`
// 	align-self: flex-start;
// `;

// const DescriptionWrapper = styled.div`
// 	display: flex;
// 	align-items: center;
// 	justify-content: flex-start;
// 	margin-top: 8px;
// `;

// const Description = styled.p`
// 	margin: 0 0 0 8px;
// 	color: #31445a;
// 	font-weight: ${(props) => props.theme.fontWeight.normal};
// 	font-size: 12px;
// 	line-height: 16px;
// `;

export const getServerSideProps = async (context) => {
	try {
		const { res } = context;
		const { query } = context;
		// res.setHeader("Cache-Control", "public, s-maxage=43200, stale-while-revalidate");
		// eslint-disable-next-line @typescript-eslint/naming-convention
		const { job, utm_source, utm_medium, utm_campaign, employer, color } =
			context.query;
		const fullURL = `${config?.websiteUrl.slice(0, -1)}${context.resolvedUrl}`;
		const availableVendor =
			context.query?.source && context.query?.source !== "false"
				? context.query?.source
				: null;
		let jobId;
		if (job?.length > 1) {
			const query = job && job.length > 1 && job[1] && job[1].split("-");
			jobId = query[query.length - 1];
		} else if (job?.length === 1) {
			[jobId] = job;
		}
		const headers = () => {
			let headerObject = {};
			if (query?.c_id) {
				headerObject = {
					"Content-Type": "application/json",
					Authorization: `Token ${query?.c_id}`,
				};
			}
			return headerObject;
		};
		const jobDataPromise = fetch(`${config.baseUrl + urls.PUBLIC_URL_JOB + jobId}/`, {
			method: "GET",
			headers: headers(),
		}).then((resp) => resp.json());

		let jobData = null;
		try {
			jobData = await jobDataPromise;
		} catch (error) {
			console.error("Error fetching job data:", error);
		}

		if (jobData?.id) {
			const pageName = "Job Details Page";
			const sectionValue = "Job Description FAQs";
			const appDeepLink = await createBranchDeepLink({
				pageType: pageName,
				notificationType: "JOB_DETAIL",
				branchStage: pageName,
				branchCampaign: "Job Description FAQs",
				channel: "Job Link",
				id: "job-deep-link",
				section: sectionValue,
				branchProps: { job_id: jobData?.id },
				utm_medium: "job_FAQs",
				utm_campaign: "job_detail_page",
			});
			jobData.deep_link = appDeepLink;
			let jobOGImageUrl = null;
			let jobOGError = null;
			try {
				jobOGImageUrl = `${
					config?.websiteUrl
				}api/og-image/og?job_title=${encodeURIComponent(
					jobData?.title
				)}&area=${encodeURIComponent(
					jobData?.location_name
				)}&company_name=${encodeURIComponent(
					jobData?.organization?.name
				)}&min_salary=${jobData?.min_salary}&max_salary=${jobData?.max_salary}${
					employer ? `&is_employer=${employer}` : ""
				}${color ? `&color=${color}` : `&color=green`}${
					jobData?.organization?.logo_url
						? `&company_logo=${jobData.organization.logo_url}`
						: ""
				}`;
			} catch (error) {
				jobOGError = error;
				console.error("Error generating OG Image: ", error);
			}

			const jobDescriptionTemplate = createJdFromJobDetails(jobData);
			const jobDescription = `<div>${
				jobData?.rich_description?.length >= 10
					? `<p>${jobData?.rich_description}</p>`
					: ""
			}</div>`;
			/* The following code is implemented for determining cut off point
			for job Description for Read Full Job Description button. Variable count is for the number of
			answers we want to show in the job description before we click on Read Full Job Description Button.
			*/
			const indexOfCutOff = (str) => {
				let count = 0;
				let cutOffElement = 0;
				let newStr = str;
				let cutOff = 0;
				while (count <= 1) {
					cutOff = newStr.indexOf("<strong>");
					cutOff += 8;
					newStr = newStr.slice(cutOff);
					count += 1;
					cutOffElement += cutOff;
				}
				return cutOffElement;
			};
			/**
			 * The following code is implemented for visually hiding the Read Full Job Description.
			 * We want the elements to be in the DOM but not visible to user, unless searhced for SEO purposes.
			 */
			const visuallyHiddenStyles = `
				position: absolute !important;
				height: 1px;
				width: 1px;
				overflow: hidden;
				clip: rect(1px 1px 1px 1px); /* For IE6 and IE7 */
				clip: rect(1px, 1px, 1px, 1px);
				white-space: nowrap; /* ensure it doesn't affect layout */
			`;
			/**
			 * We are subtracting 8 because the string <strong> is 8 characters long.
			 *
			 * The function indexOfCutOff finds the index of the second occurrence of the <strong> tag and returns the index
			 * just after that tag due to the line cutOff += 8;. By subtracting 8 from the result of indexOfCutOff, we're essentially
			 * adjusting the index to point to the beginning of that <strong> tag, rather than just after it.
			 */
			// const hiddenStartIndex = indexOfCutOff(jobDescriptionTemplate) - 8;
			const shortJobDescription = `<div>${
				jobData?.rich_description?.length >= 10
					? `<p>${jobData?.rich_description}</p>`
					: ""
			}</div>`;

			const topCompanyData = await fetch(
				`${config.baseUrl + urls.PUBLIC_URL_COMPANIES_LIST}?city_id=${
					jobData?.address?.city?.id
				}`,
				{
					method: "GET",
				}
			)
				.then((resp) => resp.json())
				.catch((e) => console.log(e));

			let jobSchema = null;
			if (jobData) {
				jobSchema = getJobSchema({
					job: jobData,
					categoryData,
					jobDescriptionTemplate,
				});
			}
			let faqSchema = null;
			if (jobData && jobData?.status === JOB_STATUS.ACTIVE) {
				faqSchema = getFAQSchema({
					jobDescriptionTemplate,
				});
			}
			return {
				props: {
					job: jobData,
					jobDescription,
					shortJobDescription,
					jobDescriptionTemplate,
					errCode: false,
					jobOGImageUrl,
					jobOGError,
					jobOGUrl: fullURL,
					jobSchema,
					faqSchema,
					slug: `/${jobData?.public_url_v2?.replace(config.websiteUrl, "")}`,
					topCompanies: topCompanyData || [],
					availableVendor,
				},
			};
		}
		return {
			notFound: true,
		};
	} catch (error) {
		return {
			notFound: true,
		};
	}
};

export default Jobs;
